import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    authData: "",
    freshTokenRetrievalTransactionCompleted: false,
  },
  mutations: {
    setAuthData(state, authData) {
      state.authData = authData;
    },
    setFreshTokenRetrievalTransactionCompleted(state, tokenRetrieved) {
      state.freshTokenRetrievalTransactionCompleted = tokenRetrieved;
    },
  },
  actions: {
    updateAuthData({ commit }, authData) {
      commit('setAuthData', authData);
    },
    updateFreshTokenRetrievalTransactionCompleted({ commit }, freshTokenRetrievalTransactionCompleted) {
      commit('setFreshTokenRetrievalTransactionCompleted', freshTokenRetrievalTransactionCompleted);
    },
  },
});